import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { SettingsView } from '../components/SettingsView';
import { AuthenticatedRoute, RouteByRole } from '../security/ProtectedRoutes';
import { UserProfile } from '../components/usermanagement/UserProfile';
import { UserChangePassword } from '../components/usermanagement/UserChangePassword';
import  Done  from '../components/usermanagement/Done';
import ViewCandidate from '../components/externalorgs/ViewCandidate';
import  { RegisterUser }  from '../components/usermanagement/RegisterUser';
// import  { RegisterCandidate }  from '../components/usermanagement/RegisterCandidate';
import TermsAndConditions from '../components/usermanagement/TermsAndConditions';
// import { PublicLandingView } from '../components/PublicLandingView';
import { LoginView } from '../components/LoginView';
import AuthOffline from '../security/AuthOffline';
import FAQ from '../components/FAQ';
import AboutUsView from '../components/AboutUsView';
import { PrivacyPolicyView } from '../components/PrivacyPolicyView';
import PrivacyStatment from '../components/PrivacyStatment';
import { HomeView } from '../components/home/HomeView';
import CandidateDetailsView from '../components/nyscandidate/CandidateDetailsView';
import { NYSView } from '../components/nyscandidate/NYSView';
import EventTrackerView from '../components/eventracker/EventTrackerView';
import CitizenScienceView from '../components/citizenscience/CitizenScienceView';
import VolunteerScientistView from '../components/volunteerscientist/VolunteerScientistView';
import UserGuideView from "../components/UserGuidesView";
import MyProgrammeView from '../components/home/MyProgrammeView';
import VolunteerHomeView from '../components/volunteerscientist/homeview';
import { NysLandingView } from '../components/nyscandidate/NYSLandingView';
import EventTrackerHome from '../components/eventracker/EventTrackerHome';
import CitizenScienceHome from '../components/citizenscience/CitizenScienceHome';

import { 
    ViewDocument, 
    EventsReport, 
    PartnerReport, 
    NYSReport, 
    STEMIOlympiadReport, 
    InvalidPage,
    CitizenScienceReport,
} from '@seims/shared';
import ProjectListHome from 'src/components/citizenscience/ProjectListHome';
import ViewProjectDetails from 'src/components/citizenscience/projectinfo/ViewProjectDetails';
import JoinProject from 'src/components/citizenscience/project-join/JoinProject';
import ProjectDetailsMore from 'src/components/citizenscience/project-join/ProjectDetailsMore';
import EventsListView from '../components/eventracker/EventsListView';




const AppRouter = ()=> {
    return (
        <Routes>
            {/* <Route path="/" element={<ToggleHomeView />} />  */}
            <Route path="/" element={<HomeView />} /> 
            <Route path="/autherror" element={<AuthOffline />} />       
            <Route path="/nys/candidate/create" element={ <RouteByRole roles={["NYS_CANDIDATE"]}>
                <CandidateDetailsView /> </RouteByRole>} />
            <Route path="/config" element={ <RouteByRole roles={["ADMIN"]}>
            <SettingsView /> </RouteByRole>} />
            <Route path="/profile" element={ <AuthenticatedRoute > <UserProfile /> </AuthenticatedRoute>} />
            <Route path="/changepassword" element={<AuthenticatedRoute > <UserChangePassword /> </AuthenticatedRoute>} />
            {/* <Route path="/usermanagement" element={<UserAdminView />} /> */}
            <Route path="/done" element={<Done />} />
            {/* <Route path="/home" element={ <PublicLandingView />} /> */}

            <Route path="/login" element={ <LoginView />} />
            <Route path="/login/:key/:isanon" element={ <LoginView />} />
            <Route path="/nys/landing" element={ <NysLandingView />} />
            <Route path="/nys/candidate/details/:key" element={ <ViewCandidate />} />
            <Route path="/register" element={ <RegisterUser/>} />
            {/* <Route path="/nys/candidate/register" element={ <RegisterCandidate/>} /> */}
            <Route path="/nys/privacy-policy" element={ <PrivacyPolicyView/>} />
            <Route path="/nys/frequently-asked-questions" element={ <FAQ/>} /> 
            <Route path="/nys/privacy-statement" element={ <PrivacyStatment/>} /> 
            <Route path="/privacy-statement" element={ <PrivacyStatment/>} /> 
            <Route path="/terms-and-conditions" element={ <TermsAndConditions/>} />
            <Route path="/public-events" element={<EventTrackerView />} />
            <Route path="/citisci" element={<CitizenScienceView />} />
            <Route path="/volusci" element={<VolunteerScientistView />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/nys/about-us" element={ <AboutUsView/>} /> 
            <Route path="/user-guides" element={<UserGuideView />} />
            <Route path="/my-dashboard" element={ <AuthenticatedRoute > <MyProgrammeView /> </AuthenticatedRoute>} />
            <Route path="/volunteer-scientist/home" element={<VolunteerHomeView />} />
            <Route path="/nys/home" element={ <NYSView />} />
            <Route path="/public-events/home" element={ <EventTrackerHome />} />
            <Route path="/citizen-scientist/home" element={ <RouteByRole roles={["CITIZEN_SCIENTIST"]}> <CitizenScienceHome /> </RouteByRole>} />
            <Route path="/my-projects" element={ <RouteByRole roles={["CITIZEN_SCIENTIST"]}> <ProjectListHome/> </RouteByRole>} />
            <Route path="/doc-repo/home" element={ <ViewDocument />} />
            <Route path="/report-events" element={<EventsReport eventType = "Event Group" filterType = "group"/>} />
            <Route path="/report-events-groups" element={<EventsReport eventType = "Event Group" filterType = "group"/>} />
            <Route path="/report-individual-events" element={ <EventsReport eventType = "Individual Event" filterType = "event"/>} />
            <Route path="/report-venue-type" element={ <EventsReport eventType = "Venue Type" filterType = "venue"/>} />
            <Route path="/report-nys" element={ <NYSReport />} />
            <Route path="/report-partnership" element={ <PartnerReport />} />
            <Route path="/report-stemi" element={ <STEMIOlympiadReport reportType="Overview"/>} />
            <Route path="/report-stemi-overview" element={ <STEMIOlympiadReport reportType="Overview"/>} />
            <Route path="/report-stemi-sector" element={ <STEMIOlympiadReport reportType = "Sector" />} />
            <Route path="/report-stemi-competition" element={ <STEMIOlympiadReport reportType = "Competition" />} />
            <Route path="/view-project/:key" element={<RouteByRole roles={["CITIZEN_SCIENTIST"]}> <ViewProjectDetails /> </RouteByRole>} />
            <Route path="/join-project" element={ <JoinProject/>} />
            <Route path="/events-list" element={ <EventsListView/>} />
            <Route path="/report-citizen-science" element={<CitizenScienceReport/>} />
         
             <Route
                path="/project/details/:key"
                element={
                    <ProjectDetailsMore />
                }
            />

            <Route path="/404/" element={ <InvalidPage/>} />
            {/* Only match this 👇️ when no other routes match */}
            <Route path="*" element={<InvalidPage subTitle={"Page Not Found"} />} />
        </Routes>
    )
}

export default AppRouter;
